import { render, staticRenderFns } from "./telemetry.vue?vue&type=template&id=2805ef56&scoped=true"
import script from "./telemetry.vue?vue&type=script&lang=js"
export * from "./telemetry.vue?vue&type=script&lang=js"
import style0 from "./telemetry.vue?vue&type=style&index=0&id=2805ef56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2805ef56",
  null
  
)

export default component.exports